<template>
  <div>
    <v-dialog v-model="dialog" max-width="800">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" text x-small v-bind="attrs" v-on="on">
          Parameter Info
          <!-- <v-icon x-small>mdi-information-outline</v-icon> -->
        </v-btn>
      </template>
      <v-card :loading="loading">
        <div class="orangeCardTitle d-flex flex-row pa-2 title">
          <v-img
            v-if="image"
            :src="image"
            contain
            max-height="40"
            max-width="80"
            class="mr-2"
          />
          <v-spacer></v-spacer>
          <div>{{ title }}</div>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </div>

        <v-card-text>
          <soft-power-grid :powers="data" class="mx-1" v-if="data" />
          <!-- {{ data }} -->
          <slot></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import SoftPowerGrid from "@/components/clStuff/SoftPowerGrid";

// import Name from "../dir/file";

export default {
  name: "ClPowerDialog",
  components: {
    SoftPowerGrid,
  },
  props: {
    lensId: null,
    lensName: { type: String, default: "Lens Brand" },
    image: null,
  },
  data: function () {
    return {
      localLensId: null,
      dialog: false,
      data: null,
      loading: false,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let path = `/lens/${this.lensId}/powers`;
      ApiServices.genericApiCall(path)
        .then((response) => {
          this.data = response.data;
          this.localLensId = this.lensId;
        })
        .catch((e) => {
          // alert(e);
          this.error = "Error loading lens data";
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    title: function () {
      let rtn = "Lens";
      if (this.lensName) rtn = this.lensName;
      return rtn + " Parameters";
    },
  },
  watch: {
    dialog: function () {
      //   console.log("dialog change!");
      if (this.dialog && this.lensId && this.lensId != this.localLensId)
        this.getData();
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
